import * as Styled from './skeleton-pill-shape.styles';
import type { SkeletonPillShapeProps } from './skeleton-pill-shape.types';

export const SkeletonPillShape = ({
  className,
  height,
  width = '100%',
  ...props
}: SkeletonPillShapeProps): JSX.Element => (
  <Styled.SkeletonPillShape
    $height={height}
    $width={width}
    className={className}
    data-xds="SkeletonPillShape"
    {...props}
  />
);

SkeletonPillShape.displayName = 'SkeletonPillShape';
